export default function When (props) {
    const d =  props.condition ? <>{props.children}</> : '';///
    return d;
}